
export const listAuctionsQuery = `query listAuctions($endTime: String!) {
  listAuctions(filter: {EndTime: {ge:$endTime}}) {
    items {
      AuctionCode
      AuctionId
      Title
      Description
      Status
      StartTime
      EndTime
      Items {
        ItemId
      }
      AuctionLocation
      BannerImageName
      NeedsCheckin
      OrganizerAddress
      OrganizerLogoName
      OrganizerName
      OrganizerWebsite
      SupportEmail
      SupportPhone
      FundName
      FundNumber
      MarketingEffort
    }
  }
}`

// gets UserId from CognitoLogin, which it gets from the user's ID token
export const getAuctionUserQuery = `query getUser {
  getUser {
    CrmId
    FirstName
    LastName
    ContactPhone
    ContactEmail
    UserId
    isTestUser
    Address {
      Street1
      Street2
      City
      State
      PostCode
      Country
    }
    PaymentMethods {
      CardType,
      NameOnCard,
      Last4,
      Expires,
      DateAdded,
    }
    MyAuctions {
      RegistrationId
      AuctionId
      TextAlertNumber
      IsCheckedIn
      QrBase64
      DateCreated
      Favorites
      Auction {
        AuctionCode
        AuctionId
        Title
        Description
        Status
        StartTime
        EndTime
        AuctionLocation
        BannerImageName
        OrganizerName
        OrganizerLogoName
        OrganizerAddress
        OrganizerWebsite
        SupportEmail
        SupportPhone
        FundName
        FundNumber
        MarketingEffort
        NeedsCheckin
        Items {
          CurrentBid
          CurrentHighBidder
          Title
          Paid
          ItemId
        }
      }
    }
  }
}`

// gets UserId from CognitoLogin, which it gets from the user's ID token
export const getBraintreeClientTokenQuery = `query getBraintreeClientToken {
  getBraintreeClientToken {
    ClientToken
    ResponseData
  }
}`

const getCommonQueryFinish = (auctionAdminData, itemAdminData) => `
  Items {
      Donor
      ImageFilename
      MinRaise
      StartingBid
      Value
      Title
      ItemId
      CurrentHighBidder
      ItemCode
      Description
      CurrentBid
      BidCount
      AuctionId
      CurrentHighBidder
      Paid
      ${itemAdminData ? itemAdminData : ""}
    }
    AuctionCode
    AuctionId
    Title
    Description
    Status
    StartTime
    EndTime
    BannerImageName
    AuctionLocation
    OrganizerName
    OrganizerLogoName
    OrganizerAddress
    OrganizerWebsite
    SupportEmail
    SupportPhone
    FundName
    FundNumber
    MarketingEffort
    NeedsCheckin
    Bids {
      BidAmount
      ItemId
      FullName
      Timestamp
      UserId
    }
    ${auctionAdminData ? auctionAdminData : ""}
  }
}`

export const getAuctionByIdQuery = `query getAuctionById($auctionId: String!) {
  getAuction(AuctionId: $auctionId) {`
  + getCommonQueryFinish()

export const getAuctionByCodeQuery = `query getAuctionByCode($auctionCode: String!) {
  getAuctionByCode(AuctionCode: $auctionCode) {`
  + getCommonQueryFinish()


///////////////////////////////////////////////////////////////////////////////////////
/// Admin only queries ////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////

export const adminListAuctionsQuery = `query adminListAuctions($status: String = "ALL") {
  adminListAuctions(filter: {Status: {eq:$status}}) {
    items {
      AuctionCode
      AuctionId
      Title
      Description
      Status
      ReviewStatus
      StartTime
      EndTime
      Items {
        BidCount
        ItemId
        Paid
      }
      AuctionLocation
      BannerImageName
      NeedsCheckin
      OrganizerAddress
      OrganizerLogoName
      OrganizerName
      OrganizerWebsite
      OwnerId
      OwnerEmail
      SupportEmail
      SupportPhone
      FundName
      FundNumber
      MarketingEffort
    }
  }
}`

export const adminGetAuctionImagePresignedUrlQuery = `query adminGetAuctionImagePresignedUrl($auctionCode: String!, $itemId: String!, $fileName: String!, $contentType: String!) {
  getPresignedUrlForUpload(AuctionCode: $auctionCode, ItemId: $itemId, FileName: $fileName, ContentType: $contentType) {
    PresignedUrl
    ResponseData
  }
}`

export const adminFindUserQuery = `query adminFindUser($cognitoLogin: String!) {
  adminFindUser(CognitoLogin: $cognitoLogin) {
    CrmId
    FirstName
    LastName
    ContactPhone
    ContactEmail
    UserId
  }
}`

// used by admin user to get more info on high bidders, will not work if called by non-admin user
export const adminGetAuctionByCodeQuery = `query adminGetAuctionByCode($auctionCode: String!) {
  adminGetAuctionByCode(AuctionCode: $auctionCode) {`
  + getCommonQueryFinish(`OwnerId
                          OwnerEmail
                          ReviewStatus
                          EventHubEventId
                          EventHubRegistrations {
                            RegistrationId
                            RegistrationStatus
                          }
                          Registrations {
                            RegistrationId
                            EventHubRegistrationId
                            DateCreated
                            User {
                              UserId
                              ContactEmail
                              CrmId
                              ContactPhone
                              FirstName
                              LastName
                            }
                          }`,
                         `PaymentDetails
                          CurrentHighBidderInfo {
                            ContactEmail
                            ContactPhone
                            CrmId
                            FirstName
                            LastName
                         }`)

